import { useState, useEffect } from 'react';

import { UploadButton, DeleteButton, ChangeButton } from './buttons';

import FileUploader from './popups/images/file-uploader-popup';
import FileTypes from '../lib/files/file-types';

export default function FileUpload({ onChange = (_, func) => { func() }, path, value = null, questionId, params = {}, onView = () => {}, onFileDelete = () => {} }) {
    const [ showFileUploader, setShowFileUploader ] = useState(false);

    const fileTypes = [
        FileTypes.PDF,
        FileTypes.TXT,
        FileTypes.DOC,
        FileTypes.DOCX,
        FileTypes.XLSX,
        FileTypes.CSV,
        'image/jpeg',
        'image/png'
    ]

    const fileDelete = () => {

    }

    useEffect(() => {

    }, [])

    return (
        <>
            <FileUploader toggled={showFileUploader}
                        onClose={() => setShowFileUploader(false)}
                        fileTypes={fileTypes}
                        onlyShow={['upload', 'browse']}
                        path={path} params={params}
                        endpoint={`/api/connector/file-upload`}
                        questionId={questionId}

                        onResourceSelect={(response) => {
                            setShowFileUploader(false);
                            onChange(response);
                        }}/>

            <div className="document-upload__outer">
                <div  className="document-upload__container">
                    <div onClick={onView} className={`document-upload ${value !== null ? 'document-upload--successfull' : ''}`}>
                        <img src={"/assets/" + (value !== null ? 'document.svg': 'plus.svg')} />
                    </div>
                    { value !== null && <p className="document-upload__file">{value?.file?.name}</p> }
                </div>
                <div className="document-upload__inner">
                    { value !== null ?
                        <>
                            <DeleteButton onClick={onFileDelete}/>
                        </> :
                        <UploadButton onClick={() => setShowFileUploader(true)}/>
                    }
                    <p className="document-upload-inner__text">Files must be below 5mb</p>
                </div>
            </div>
        </>
    )
}
